module.exports = __webpack_public_path__ + "img/login_icon3.d2ca7daa.png";